import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.username, form.password);
      const from = location.state?.from || (user.ruolo === 'esterno' ? '/portale' : '/');
      navigate(from, { replace: true });
    } catch (e) {
      setError(typeof e === 'string' ? e : 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-700 to-brand-900 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Filigrana: qui non ci sono dati da leggere, quindi il marchio può
          respirare. Sulle pagine con tabelle sarebbe l'opposto — sotto le
          cifre una filigrana le rende solo più faticose da leggere.
          aria-hidden: è decorazione, gli screen reader la saltano. */}
      <img src="/pittogramma.png" alt="" aria-hidden="true"
           className="pointer-events-none select-none absolute"
           style={{ width: '34rem', maxWidth: 'none', left: '-9rem', bottom: '-11rem',
                    filter: 'brightness(0) invert(1)', opacity: 0.06 }} />
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8">
        <div className="text-center mb-8">
          {/* Su fondo bianco il marchio si usa intero, com'è disegnato */}
          <img src="/logo-sinthema.png" alt="Sinthema"
               className="w-56 h-auto mx-auto mb-4" />
          <div className="text-xs text-gray-400 uppercase tracking-[0.2em]">Gestionale</div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">Username</label>
            {/* Niente correzioni automatiche sul nome utente: sul telefono la
                maiuscola iniziale e l'autocorrettore trasformano il nome in
                qualcosa che il gestionale non riconosce. */}
            <input
              className="input"
              autoFocus
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
            />
          </div>
          <div>
            <label className="label">Password</label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary w-full mt-2"
            disabled={loading}
          >
            {loading ? 'Accesso in corso…' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}
